import { ID } from '@rossum/api-client';

export const supportedAnnotationViews = [
  'attachments',
  'duplicates',
  'emails',
  'activities',
  'files',
  'comments',
  'customRelation',
  'documentHistory',
] as const;

export type SupportedAnnotationView = (typeof supportedAnnotationViews)[number];

export type SelectAnnotationParams = {
  annotationUrl: string;
  view: SupportedAnnotationView;
  relationId?: ID;
};
